import React, { useState, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TabPanel from '../materialFunctions/TabPanel';
import { getContactActivities } from '../../actions/activity';
import { makeStyles, AppBar, Tab, Tabs } from '@material-ui/core';
// import moment from 'moment';

const LowerPageView = ({
  getContactActivities,
  contact,
  activity: { activities }
}) => {
  const useStyles = makeStyles(theme => ({
    root: { background: 'red' },
    AcBody: {
      margin: '0 0 1em 0',
      background: '#F2F4F4',
      color: '#333',
      height: '170px'
    },
    AcHead: {
      background: '#D5D8DC',
      padding: '5px'
    },
    AcFooter: { padding: '5px' },

    actionButton: {
      display: 'flex',
      marginBottom: '5px'
    },
    actionName: {
      width: '80%',
      textAlign: 'left'
    },
    actionTime: {}
  }));

  const classes = useStyles();

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (contact) {
      getContactActivities(contact._id);
    }
  }, [getContactActivities]);

  return (
    <div>
      <AppBar position='static'>
        <Tabs value={value} onChange={handleChange}>
          <Tab label='Activities' />
          <Tab label='Actions' />
          <Tab label='Deals' />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <Fragment>
          {activities && activities.length > 0 && (
            <Fragment>
              {activities.map(activity => (
                <div className={classes.AcBody}>
                  <h3 className={classes.AcHead}>{activity.type}</h3>
                  <ul>
                    <li className={classes.AcFooter}>{activity.name}</li>
                  </ul>
                </div>
              ))}
            </Fragment>
          )}
        </Fragment>
      </TabPanel>
      <TabPanel value={value} index={1}>
        {activities && activities.length > 0 && (
          <Fragment>
            {activities.map(activity => (
              <Fragment>
                {activity.type === 'Action' && (
                  <Fragment>
                    <div className={classes.AcBody}>
                      <h3 className={classes.AcHead}>{activity.type}</h3>
                      <ul>
                        <li className={classes.AcFooter}>{activity.name}</li>
                      </ul>
                    </div>
                  </Fragment>
                )}
              </Fragment>
            ))}
          </Fragment>
        )}
      </TabPanel>
      <TabPanel value={value} index={2}>
        {activities && activities.length > 0 && (
          <Fragment>
            {activities.map(activity => (
              <Fragment>
                {activity.type === 'Deal' && (
                  <Fragment>
                    <div className={classes.AcBody}>
                      <h3 className={classes.AcHead}>{activity.type}</h3>
                      <ul>
                        <li className={classes.AcFooter}>{activity.name}</li>
                      </ul>
                    </div>
                  </Fragment>
                )}
              </Fragment>
            ))}
          </Fragment>
        )}
      </TabPanel>
    </div>
  );
};

LowerPageView.propTypes = {
  getContactActivities: PropTypes.func.isRequired,
  contact: PropTypes.object.isRequired,
  activity: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  activity: state.activity
});

export default connect(mapStateToProps, { getContactActivities })(
  LowerPageView
);



// WEBPACK FOOTER //
// ./src/components/contact/LowerPageView.js